import React from 'react';
import ServicePageTemplate from '@/components/ServicePageTemplate';

const DesbloqueioPage: React.FC = () => {
  return <ServicePageTemplate serviceSlug="desbloqueio" />;
};

export default DesbloqueioPage;
